import { Box, Link, Stack, Typography, useTheme } from "@mui/material";
import { useResolvedPageBreadcrumbOverrides } from "components/ui/PageBreadcrumbContext";
import { Breadcrumbs } from "components/ui/StyledMuiComponents";
import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { resolveBreadcrumbs } from "routes/breadcrumbConfig";

const PageBreadcrumbs = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const overrides = useResolvedPageBreadcrumbOverrides();
  const items = resolveBreadcrumbs(pathname, overrides);

  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      mb={0}
      sx={{ minWidth: 0 }}
      separator={
        <Typography color="text.secondary" sx={{ fontSize: "1rem" }}>
          /
        </Typography>
      }
    >
      {items.map(({ href, icon: Icon, isCurrentPage, label }) => {
        const content = (
          <Stack
            alignItems="center"
            direction="row"
            spacing={1}
            sx={{ minWidth: 0 }}
          >
            <Box
              component={Icon}
              fontSize="large"
              sx={{ color: isCurrentPage ? "text.primary" : "text.secondary" }}
            />
            <Typography
              color={isCurrentPage ? "text.primary" : "text.secondary"}
              sx={{
                fontSize: theme.typography.body1.fontSize,
                fontWeight: isCurrentPage ? 600 : 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {label}
            </Typography>
          </Stack>
        );

        if (isCurrentPage || !href) {
          return <Box key={`${label}-current`}>{content}</Box>;
        }

        return (
          <Link
            color="inherit"
            component={RouterLink}
            key={href}
            sx={{ textDecoration: "none" }}
            to={href}
            underline="hover"
          >
            {content}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default PageBreadcrumbs;
